import { render, staticRenderFns } from "./TabelaMateriaisProtocolo.vue?vue&type=template&id=5dc2561e&scoped=true&"
import script from "./TabelaMateriaisProtocolo.vue?vue&type=script&lang=js&"
export * from "./TabelaMateriaisProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMateriaisProtocolo.vue?vue&type=style&index=0&id=5dc2561e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2561e",
  null
  
)

export default component.exports